
import type {
  GetAnalyticsTotalsPayload,
  GetAnalyticsStatisticsPayload,
  GetAnalyticsScansMapPayload,
  GetAnalyticsRoiPayload,
  AnalyticsFilters,
} from './types'
import type { ActionCallback, IValidationCallback } from '../model'

import { Actions } from './types'


export const getAnalyticsTotals = (
  payload?: GetAnalyticsTotalsPayload,
  callback?: IValidationCallback
): ActionCallback => ({
  type: Actions.GET_ANALYTICS_TOTALS,
  payload,
  callback,
})

export const getAnalyticsStatistics = (
  payload?: GetAnalyticsStatisticsPayload,
  callback?: IValidationCallback
): ActionCallback => ({
  type: Actions.GET_ANALYTICS_STATISTICS,
  payload,
  callback,
})

export const getAnalyticsScansMap = (
  payload?: GetAnalyticsScansMapPayload,
  callback?: IValidationCallback
): ActionCallback => ({
  type: Actions.GET_ANALYTICS_SCANS_MAP,
  payload,
  callback,
})

export const getAnalyticsRoi = (
  payload?: GetAnalyticsRoiPayload,
  callback?: IValidationCallback
): ActionCallback => ({
  type: Actions.GET_ANALYTICS_ROI,
  payload,
  callback,
})

/**
 * The HERO's ROI request. Same endpoint and same payload shape as `getAnalyticsRoi`,
 * different action type — see `Actions.GET_ANALYTICS_ROI_HERO` for why sharing one slot
 * between two differently-scoped requests is a race, not a saving.
 */
export const getAnalyticsRoiHero = (
  payload?: GetAnalyticsRoiPayload,
  callback?: IValidationCallback
): ActionCallback => ({
  type: Actions.GET_ANALYTICS_ROI_HERO,
  payload,
  callback,
})

export const setAnalyticsFilters = (payload: Partial<AnalyticsFilters>) => ({
  type: Actions.SET_ANALYTICS_FILTERS,
  payload,
})
